export const GET_GLOBAL_SETTINGS = "GET_GLOBAL_SETTINGS";
export const GET_GLOBAL_CATEGORIES = "GET_GLOBAL_CATEGORIES";
export const GET_GLOBAL_FAVOURITE_LISTS = "GET_GLOBAL_FAVOURITE_LISTS";